import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./Header.css";

function Header() {
    return (
        <header>
            <h1 id="mainTitle">My Day</h1>
            <h4>Tuesday, March 10</h4>
        </header>
    );
}

export default Header;